import { useCallbackRef } from '@chakra-ui/react';
import { Client } from '@twilio/conversations';
import { useCallback } from 'react';
import useSWR from 'swr';

import { useStores } from '@/hooks/useStores';

export const useConversation = (client: Client, sid: string) => {
  const { store } = useStores();
  const key = `conversation/${sid}`;

  const { data: conversation, ...swr } = useSWR(client && sid ? key : null, async () => {
    await store.request(`twilio_conversations/${sid}/participants`, 'POST', undefined);

    const activeConversation = await client.getConversationBySid(sid);

    return activeConversation;
  });

  const leave = useCallbackRef(async () => {
    if (conversation?.status === 'joined') {
      await conversation?.leave();
    }
  });

  const sendMessage = useCallback(
    async (messageBody: string): Promise<void> => {
      await conversation?.sendMessage(messageBody);
    },
    [conversation]
  );

  return { ...swr, data: conversation, sendMessage, leave };
};
